import { Overview } from "./home";

export function OverviewPage() {
  return <Overview />;
}
